import { combineReducers } from 'redux';
import quoteReducer from './quote/reducer';

export default combineReducers({
	quote: quoteReducer,
});
